module.exports = __webpack_public_path__ + "static/media/ic_setting_gray.bc23dd56.svg";